import { selectors as makePaymentSelectors } from './makePayment';
import { selectors as paymentDetailsSelectors } from './paymentDetails';

export const selectors = {
  ...makePaymentSelectors,
  ...paymentDetailsSelectors,
};
